module.exports = {
      id: "canvas-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#canvas",
      toString: function () {
        return this.url;
      }
    }